import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import BlockContent from '../../components/BlockContent';
import BannerWidget from '../../components/BannerWidget';
import MetaTags from 'react-meta-tags';
import {
  getCurrentBanner,
  getOffersArchive,
  getOffersByAlias,
  getAllCurrentActiveOffers,
} from './requests';
import './index.css';
import { OFFERS } from '../../constants/routes';
import { OFFERS_BY_ALIAS_ROUTE, OFFERS_ARCHIVE_ROUTE } from '../../constants/redirect';
import { formatClientDateRange } from '../../constants/dateTimeFormat';
import SvgArrow from '../../components/Svg/SvgArrow';

export default function OffersDetail() {
  const [offerById, setOfferById] = useState({});
  const [prewiewArchive, setPrewiewArchiwe] = useState({});
  const [bannerData, setBannerData] = useState(null);
  const [activeOffers, setActiveOffers] = useState([]);
  const { alias } = useParams();

  const processingRequest = async () => {
    const currentOffer = (await getOffersByAlias(alias)).data;
    setActiveOffers(
      (await getAllCurrentActiveOffers()).data.filter(
        (elem) => elem.picture && elem.id != currentOffer.id,
      ),
    );
    setOfferById(currentOffer.picture ? currentOffer : {});
    setBannerData((await getCurrentBanner()).data);
    setPrewiewArchiwe((await getOffersArchive()).data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    processingRequest();
    return () => {
      setOfferById({});
      setPrewiewArchiwe({});
      setActiveOffers([]);
    };
  }, [alias]);

  return (
    <div className="page-offers-detail">
      <BlockContent>
        <MetaTags>
          <title>{offerById.title}</title>
          <meta name="description" content={offerById.title} />
        </MetaTags>
        <div className="big-column">
          {offerById.picture && (
            <div className="current-offer__container">
              <div className="current-offer__dates">
                {formatClientDateRange(offerById.publish_date, offerById.unpublish_date)}
              </div>
              <div className="current-offer__title">{offerById.title}</div>
              <div className="current-offer__image">
                <img src={offerById.picture ? offerById.picture.replace('static', '') : ''} alt={offerById.title} />
              </div>
              <div
                className="content-editor"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: offerById.content }}
              />
              <div
                className="content-editor"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: offerById.google_form ? offerById.google_form : '' }}
              />
            </div>
          )}
          <Link to={OFFERS} className="button-back">
            <div className="button-back__text">Вернуться назад</div>
            <SvgArrow filled direction="left" color="purple" size={26} />
          </Link>
        </div>
        <div className="small-column">
          {activeOffers.length > 0 && activeOffers.map((elem) => (
            <BannerWidget
              key={elem.alias ?? elem.id}
              local
              title={elem.title}
              img={elem.picture.replace('static', '')}
              redirect={OFFERS_BY_ALIAS_ROUTE + elem.alias}
            />
          ))}
          {prewiewArchive && (
            <BannerWidget
              local
              title="Архив"
              img={prewiewArchive.hasOwnProperty('picture') ? prewiewArchive.picture.replace('static', '') : ''}
              redirect={OFFERS_ARCHIVE_ROUTE}
            />
          )}
          {bannerData && bannerData.map((elem, index) => (
            <BannerWidget
              key={elem.id ?? elem.link ?? `banner-${index}`}
              img={elem.picture}
              redirect={elem.link}
            />
          ))}
        </div>
      </BlockContent>
    </div>
  );
}
